// Select all iframes with a data-src attribute for lazy loading
const iframes = document.querySelectorAll('iframe[data-src]');

let observer = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      loadElement(entry.target);
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.01 });  // threshold can be adjusted based on when you want to load the iframe

// Attach observer to each iframe
iframes.forEach(iframe => {
  observer.observe(iframe);
});

function loadElement(element) {
  // Ensure the element is an iframe and has a data-src attribute
  if (element.tagName === 'IFRAME' && element.getAttribute('data-src')) {
    const src = element.getAttribute('data-src');
    element.src = src;
    element.removeAttribute('data-src');  // Optionally remove the data-src attribute after loading
    
  }
}
